import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, LinkedinIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const team = [{
  name: 'Alex Lazich',
  role: 'Founder & CEO',
  image: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/69c4a78d-9834-47a7-b2b9-f26dfaf63c78/alex-headshot.jpg",
  linkedin: 'https://www.linkedin.com/in/alex-lazich-558824118/'
}, {
  name: 'Jesse Williams',
  role: 'Founder & CTO',
  image: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/69c4a78d-9834-47a7-b2b9-f26dfaf63c78/jesse-headshot.jpg",
  linkedin: 'https://www.linkedin.com/in/jessewilliams3/'
}, {
  name: 'Ben Folks',
  role: 'Founder & Engineer',
  image: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/69c4a78d-9834-47a7-b2b9-f26dfaf63c78/ben-headshot.jpg",
  linkedin: 'https://www.linkedin.com/in/ben-folks-595b7139/'
}, {
  name: 'Emily Nucci',
  role: 'Implementations',
  image: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hpwwowkqzxwbasxuhq2t8d/69c4a78d-9834-47a7-b2b9-f26dfaf63c78/emily-headshot.jpg",
  linkedin: 'https://www.linkedin.com/in/emily-n-b12854191/'
}];
export function AboutUsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-navy text-white font-sans selection:bg-violet-electric/30 pt-32 pb-20" data-id="element-533" data-mp="37y3tfq0pyhhn">
      {/* Hero */}
      <section id="hero" className="relative px-6 mb-32" data-id="element-534" data-mp="3cxzylsl5keys">
        <div className="max-w-4xl mx-auto text-center" data-id="element-535" data-mp="3hw1hodikwea9">
          <motion.span initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-violet-electric text-sm font-semibold tracking-widest uppercase mb-6 block" data-id="element-536" data-mp="3hv9n960pwmlk">

            Why Thruline
          </motion.span>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8" data-id="element-537" data-mp="2u5fa0nchkw0s">

            The amazing team behind our company
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-xl text-white/60 max-w-2xl mx-auto leading-relaxed" data-id="element-538" data-mp="2vv1875clmfvb">

            Our team's experience across manufacturing verticals gives us the
            insight to know and understand what makes your organization unique.
          </motion.p>
        </div>
      </section>

      {/* Team Grid */}
      <section id="team" className="px-6 mb-32" data-id="element-539" data-mp="2856vqow6ytbl">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-540" data-mp="3ok84dxokytde">
          {team.map((member, index) => <motion.div key={member.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="text-center group" data-id="element-541" data-mp="3jly8tlyy1qr9" data-mpi={index}>

              <div className="relative w-48 h-48 mx-auto mb-6 rounded-full overflow-hidden border-4 border-white/5 group-hover:border-violet-electric/50 transition-colors duration-300" data-id="element-542" data-mp="3i4hsmt8s8vb1">
                <img src={member.image} alt={member.name} className="w-full h-full object-cover transition-all duration-500" data-id="element-543" data-mp="dq1h6m9pzizu" />

              </div>
              <h3 className="text-2xl font-bold mb-2" data-id="element-544" data-mp="iocq8us6xph0">{member.name}</h3>
              <p className="text-white/60 mb-4" data-id="element-545" data-mp="4y95y9cvg5u7">{member.role}</p>
              <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-white/5 hover:bg-violet-electric hover:text-white transition-colors text-white/40" data-id="element-546" data-mp="8z1hj997umtn">

                <LinkedinIcon className="w-4 h-4" data-id="element-547" data-mp="11gdt08835zvp" />
              </a>
            </motion.div>)}
        </div>
      </section>

      {/* Mission */}
      <section id="mission" className="px-6" data-id="element-548" data-mp="39u27j9y9z0p5">
        <div className="max-w-4xl mx-auto text-center bg-white/[0.02] border border-white/10 rounded-3xl p-12 md:p-20 relative overflow-hidden" data-id="element-549" data-mp="34wag0h1jlglh">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-violet-electric via-magenta-hot to-violet-electric" data-id="element-550" data-mp="300bo4jh09ggb" />

          <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-551" data-mp="3snfsqnc6rsrk">Our Mission</h2>
          <p className="text-2xl md:text-3xl text-white/80 font-light leading-relaxed mb-12" data-id="element-552" data-mp="3nntfwf09seja">
            Building the first ERP Factory for the physical world
          </p>

          <Link to="/resources/thesis" className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white text-navy font-semibold text-base hover:bg-white/90 transition-all hover:shadow-lg hover:shadow-white/10" data-id="element-553" data-mp="3iv0cpvkg9e9b">

            Read Our Thesis
            <ArrowRightIcon className="w-4 h-4" data-id="element-554" data-mp="ah1hwx97ryxe" />
          </Link>
        </div>
      </section>
    </div>;
}